import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Recipe } from '@app/models/item/recipe';
import { Translation } from '@app/models/translations';

export interface ProductionCardDyeingCycleRecipeValues {
  id?: string;
  productionCardDyeingCycleReference: string;
  recipeReference: string;
  recipeNumber?: string;
  actualValues: ActualValueEntry[];
  status: RecipeValuesStatus;
  createdBy?: string;
  createdDate?: Date;
  modifiedBy?: string;
  modifiedDate?: Date;
}

export interface ActualValueEntry {
  processSnapshotId: string;
  stepOrder: number | null;
  itemCode: string;
  itemDescription?: string;
  estimatedQuantity?: number;
  actualQuantity?: number;
  unit?: string;
  notes?: string;
  consumptionInKg?: number;
  isManual?: boolean;
  /** On-hand balance of itemCode at the chemical consumables warehouse (NT.WH-CON-1). Read-only, populated by the backend. */
  currentInventory?: number;
}

export enum RecipeValuesStatus {
  InProgress = 0,
  Completed = 1,
}

export interface AssociateRecipeRequest {
  recipeReference: string;
}

export interface PreviewItem {
  stepOrder: number | undefined;
  stepName: string | undefined;
  itemCode: string;
  itemDescription: string | undefined;
  estimatedQuantity: number | undefined;
  /** Sierra.Item.Models IngredientUnit enum (Percent = 0, GramsPerLiter = 1) — serialized as the raw numeric value. */
  unit: string | number | undefined;
  currentInventory: number | undefined;
}

/**
 * Enrichment (description + current inventory) for a single ItemCode within a not-yet-associated
 * recipe preview. Wraps the shared Recipe (Sierra.Item.Models) without modifying it — see
 * Production.API's RecipePreviewDto (PBI 4852).
 */
export interface RecipePreviewItem {
  itemCode: string;
  itemDescription?: string;
  currentInventory?: number;
}

export interface RecipePreview {
  recipe: Recipe;
  itemEnrichments: RecipePreviewItem[];
}

/** Chemical consumables warehouse (NT.WH-CON-1) code + localized name, for the consumption notice. */
export interface ConsumptionWarehouseLocation {
  code: string;
  name: Translation;
}

export interface CycleRecipeValuesForm {
  recipeReference: FormControl<string | null>;
  actualValues: FormArray<FormGroup<ActualValueEntryForm>>;
}

export interface ActualValueEntryForm {
  processSnapshotId: FormControl<string>;
  stepOrder: FormControl<number | null>;
  itemCode: FormControl<string>;
  itemDescription: FormControl<string | null>;
  estimatedQuantity: FormControl<number | null>;
  actualQuantity: FormControl<number | null>;
  unit: FormControl<string | null>;
  notes: FormControl<string | null>;
  actualKg: FormControl<number | null>;
  consumptionInKg: FormControl<number | null>;
  isManual: FormControl<boolean>;
  confirmed: FormControl<boolean>;
  currentInventory: FormControl<number | null>;
}
